import React from "react";
import "./Category.css";
import { Link } from "react-router";

interface CategoryProps {
  name: string;
  id: number;
}

export default function Category(props: CategoryProps) {
  return (
    <Link key={props.id} to={`/list/${props.id}`} className="Category">
      {props.name}
    </Link>
  );
}
